import { ApiResponse, getRequest } from "@/data/apiClient";
import { App } from "@/interfaces/common.interfaces";

export const getApps = async (): Promise<ApiResponse<App[]>> =>
  getRequest("/apps");

export const getAccountsApps = async (): Promise<ApiResponse<App[]>> =>
  getRequest("/applications");
